import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useMutation } from '@tanstack/react-query'
import { propertyQueryFn, propertyUseQuery } from 'Services/reactQuery'
import { isNilEmpty } from 'Utils'
import { rateData } from './constant'
import MortgageCalculator from './MortgageCalculator'

export const useSubmitMortgageRequest = () => (
  useMutation({
    mutationFn: (formData) => propertyQueryFn({
      url: 'mortgage-request',
      reqData: {
        mode: 'POST',
        data: formData,
      },
    })(),
  })
)

export const useFetchMortgageRates = ({ params, onSuccess }) =>
  propertyUseQuery(
    ['mortgageRates', params?.listingId],
    propertyQueryFn({
      url: 'mortgage/get-rates',
      reqData: {
        mode: 'GET',
        data: params,
      },
    }),
    {
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      enabled: !!params?.purchase_price,
      onSuccess,
    },
  )

const MortgageCalculatorApiContainer = props => {
  const [interestRate, updateInterestRate] = useState(rateData[0].value)
  const { mutate: submitMortgage } = useSubmitMortgageRequest()
  const googleAnalyticsEventsHandler = action =>
    props.googleAnalyticsEvent({
      category: 'Mortgage Calculator',
      action,
    })
  const { data: interestRateData } = useFetchMortgageRates({
    params: {
      purchase_price: props.price,
      down_payment: props.price * 0.1,
      records_per_rate_type: 1,
      listing_id: props.listingId,
    },
    onSuccess: () => googleAnalyticsEventsHandler('[Api Called]'),
  })

  useEffect(() => {
    if(!isNilEmpty(interestRateData)) updateInterestRate(interestRateData?.[0]?.rate)
  }, [interestRateData])

  return (
    <MortgageCalculator
      rate={interestRate}
      {...props}
      submitMortgage={submitMortgage}
      googleAnalyticsEventsHandler={googleAnalyticsEventsHandler}
    />
  )
}

MortgageCalculatorApiContainer.propTypes = {
  props: PropTypes.shape({}),
  price: PropTypes.number,
  googleAnalyticsEvent: PropTypes.func,
  listingId: PropTypes.number,
}

export default MortgageCalculatorApiContainer
